// @flow

import type { UrlCriteria } from './_types';

const formatUrlCriteria = (
    {
        categoryId,
        manufacturerId,
        adConditionId,
        onlyRental,
        min,
        max,
        sortType,
        sortDirection,
        advertiserId
    }: UrlCriteria = {}
): string => {
    const urlParts: string[] = ['ads', 'list'];

    if (categoryId) {
        urlParts.push(`cat:${categoryId}`);
    }

    if (manufacturerId) {
        urlParts.push(`man:${manufacturerId}`);
    }

    if (adConditionId) {
        urlParts.push(`adc:${adConditionId}`);
    }

    if (onlyRental) {
        urlParts.push('rent:on');
    }

    if (min) {
        urlParts.push(`min:${min}`);
    }

    if (max) {
        urlParts.push(`max:${max}`);
    }

    if (sortType) {
        urlParts.push(`sor:${sortType}`);
    }

    if (sortDirection) {
        urlParts.push(`dir:${sortDirection}`);
    }

    if (advertiserId) {
        urlParts.push(`adv:${advertiserId}`);
    }

    return `/${urlParts.join('/')}`;
};

export default formatUrlCriteria;
